<template>
  <div class="home">
    <div class="w-all w-minw bd-sd-b hg-40 bg-c-ffffff">
      <div class="w-main m-auto">
        <div class="fr">
          <div class="hover-ucenter fl">
            <div class="top_ucenter fl fs-12 line-h40"></div>
          </div>

          <a class="fs-12 ftc-000000 line-h40 go-login more" href="/show">
            <i class="iconfont icon-member p-l-20 hg-40 fl m-r-6"></i>
            您好，{{
            nickname
            }}
          </a>
          <a href="/login" class="fs-12 ftc-000000 line-h40 m-l-4 more">[退出]</a>
          <span class="fs-12 ftc-000000 line-h40 m-l-15">|</span>

          <div class="fr m-l-15">
            <div class="my-lesson">
              <a href="/cgList" class="fl fs-12 ftc-000000 line-h40">
                <i class="iconfont icon-play1 m-r-4"></i>作品列表
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="toppic wall mb10">
      <div class="picself wall">
        <ul>
          <li>
            <a href="/Show">首页</a>
          </li>
          <li>
            <a href="/Show">活动启事</a>
          </li>
          <li>
            <a href="/cgzp">课改成果展评</a>
          </li>
          <li>
            <a href="/lwzp">原创成果展评</a>
          </li>
          <li>
            <a href="/lwList">上传作品</a>
          </li>
          <li>
            <a href="/hjcx">获奖查询</a>
          </li>
        </ul>

        <!-- <a class="uploadfile"  href="/bmcs">上传作品</a> -->
      </div>
    </div>
    <div class="main w1200">
      <div class="w1200">
        <!-- 表单内容开始-->
        <div class="update-div">
 <el-input v-model="worksname" placeholder="请输入上传作品的题目，不得超过20个字"></el-input>
          <a href="javascript:;" class="file">
            上传学术成果申请表
            <input
              type="file"
              @change="uploadInputchange1"
              id="uploadFileInput1"
             accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
            />
          </a>
          <a href="https://ywbs1.zhyww.cn/xszp/cgsqb.doc" class="sqs-a">  <i class="el-icon-link" style="font-size: 20px; color: #409eff"></i>下载学术成果申请表模板</a>
          <div v-show="isShow1s" class="fileName">
            {{fileNames}}
            <span style="margin-left: 5px;"></span>
            {{ percent }}%
          </div>
          <br><br>
          
          <a href="javascript:;" class="file" style="padding: 4px 18px;">
            上传学术成果作品 
            <input
              type="file"
              @change="uploadInputchange"
              id="uploadFileInput"
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
            />
          </a>
          <!-- <span class="sqs-a">注：参赛作品统一用word上传</span> -->
              
          <el-input v-model="doc" v-show="isShow2"></el-input>
        
          

          <div v-show="isShow1" class="fileName">
            {{fileName}}
            <span style="margin-left: 5px;"></span>
            {{ percent }}%
          </div>
           <div class="save-b">
             <el-button type="primary" @click="saveWork">保存</el-button>
           </div>
        </div>
        

        <!-- 表单内容结束-->
      </div>
    </div>
    <div
      class="footer"
      style="
        background: url(('../../assets/images/foot.png')) top center no-repeat;
      "
    >
      <div class="menu">
        <div class="box">
          <a href="http://www.zhyww.cn/ywbs/bsjj/202006/115472.html" target="_blank">关于我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115483.html"
            target="_blank"
          >联系我们</a>&nbsp;|&nbsp;
          <a
            href="http://www.zhyww.cn/ywbs/bsjj/202006/115484.html"
            target="_blank"
          >版权声明</a>
        </div>

        <div class="copyright">
          <p>
            语文网版权所有 未经书面授权 不得复制或建立镜像
            晋公网安备14010902000073号
          </p>
          <p>
            增值电信业务经营许可证晋B2-20030007 新出网许（晋）字005号
            <a
              href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
              target="_blank"
            >晋ICP备09011058号</a>
            <a
              href="http://webscan.360.cn/index/checkwebsite/url/www.zhyww.cn"
              name="f7c1c8d71288f01cb16d63638e8f82bc"
            >网站安全检测平台</a>
          </p>
        </div>

        <a href="http://webscan.qianxin.com/safe/detail/?query=www.zhyww.cn">
          <img
            border="0"
            src="http://webscan.qianxin.com/api/authcode?code=fd753cb81c61b4824c3645292d170f85"
            style="display: none"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import { GetOrderInfo,Inscgzp } from "@/request/api";
export default {
  data() {
    return {
      isShow1: false,
      isShow1s: false,
      isShow2: false,
      isShow11: false,
      doc: null,
      docs: null,
      fileName: null,
      fileNames: null,
      percent: 0,
      centerDialogVisible: false,
      username: null,
      phone: null,
      schoolArea: null,
      workUnit: null,
      shippingAddress: null,
      studySection: null,
      userid: null,
      workstype:null,
      oid:null,
      orderno:null,
      worksname:null,
    };
  },
  created() {
    var openid = sessionStorage.getItem("openid");
    if (openid == null) {
      this.$router.push({ path: "/" });
    }
    this.nickname = sessionStorage.getItem("nickname");
    this.oid = sessionStorage.getItem("oid");
    let that = this;

  },
  methods: {

    uploadInputchange() {
      let file = document.getElementById("uploadFileInput").files[0]; //选择的图片文件
      this.uploadImgToQiniu(file);
    },
    uploadInputchange1() {
      let file = document.getElementById("uploadFileInput1").files[0]; //选择的图片文件
      this.uploadImgToQiniu1(file);
    },
    uploadImgToQiniu1(file) {
      let data = new FormData();
      var that = this;
      let token = null;
      this.$axios
        .get("https://appconsole.zhyww.cn/api/qiniuToken")
        .then(function(res) {
          token = res.data;
          console.log("*****************:", token);
          console.log("token:", token);
          let uptoken = token;
          let key = "xszp/" + new Date().getTime() + file.name;
          that.fileNames = file.name;
          var config = {
            useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
            //region: qiniu.region.z0,      //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
            domain: "https://ywbs1.zhyww.cn", //配置好的七牛云域名  如   https://cdn.qniyun.com/
            chunkSize: 400, //每个分片的大小，单位mb，默认值3
            forceDirect: true //直传还是断点续传方式，true为直传
          };
          var putExtra = {
            fname: file.name, //文件原始文件名
            params: {},
            mimeType: [] || null
            // ...config,
          };
          var observable = qiniu.upload(file, key, uptoken, putExtra, config);
          observable.subscribe({
            next: result => {
              //主要用来展示进度
              that.isShow1s = true;

              console.log(result.total.percent);

              that.percent = parseFloat(result.total.percent).toFixed(2);
            },

            complete: result => {
              //上传成功后触发。包含文件地址。
              that.docs = "https://ywbs1.zhyww.cn/" + result.key;
              that.isShow1s = true;

              console.log(that.docs);
              //alert("上传成功");
              that.$alert("上传成功", "上传", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                }
              });
              resolve(result);
            }
          });
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    uploadImgToQiniu(file) {
      let data = new FormData();
      var that = this;
      let token = null;
      this.$axios
        .get("https://appconsole.zhyww.cn/api/qiniuToken")
        .then(function(res) {
          token = res.data;
          console.log("*****************:", token);
          console.log("token:", token);
          let uptoken = token;
          let key = "xszp/" + new Date().getTime() + file.name;
          that.fileName = file.name;
          var config = {
            useCdnDomain: true, //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
            //region: qiniu.region.z0,      //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域。  我这里是华东区
            domain: "https://ywbs1.zhyww.cn", //配置好的七牛云域名  如   https://cdn.qniyun.com/
            chunkSize: 400, //每个分片的大小，单位mb，默认值3
            forceDirect: true //直传还是断点续传方式，true为直传
          };
          var putExtra = {
            fname: file.name, //文件原始文件名
            params: {},
            mimeType: [] || null
            // ...config,
          };
          var observable = qiniu.upload(file, key, uptoken, putExtra, config);
          observable.subscribe({
            next: result => {
              //主要用来展示进度
              that.isShow11 = false;
              that.isShow1 = true;
              that.showRentPrise = true;
              console.log(result.total.percent);

              that.percent = parseFloat(result.total.percent).toFixed(2);
            },

            complete: result => {
              //上传成功后触发。包含文件地址。
              that.doc = "https://ywbs1.zhyww.cn/" + result.key;
              that.isShow1 = true;
              that.showRentPrise = false;
              console.log(that.doc);
              //alert("上传成功");
              that.$alert("上传成功", "上传", {
                confirmButtonText: "确定",
                callback: action => {
                  this.$message({
                    type: "info",
                    message: `action: ${action}`
                  });
                }
              });
              resolve(result);
            }
          });
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    saveWork(){
       var that = this;
       if(that.doc == null){
          alert("还未上传作品")
          sessionStorage.removeItem("oid");
       } else {
         if(that.docs == null){
            alert("还未上传身申请表")
              sessionStorage.removeItem("oid");
            } else{
          Inscgzp({userid:sessionStorage.getItem("userId"),worksname:that.worksname,worksPath:that.doc,cgsqtable:that.docs}).then(function(res) {
            console.log("res2222:", res.data.states);
            if (res.data.states == 1) {
              alert("保存成功！");
              that.$router.push({ path: "/cgList" });
            } else {
              alert("保存失败");
              that.$router.push({ path: "/cgList" });
            }
          });
            }

       }
    }
  }
};
</script>
